import { toast } from 'sonner';

/**
 * Say why a dashboard link landed on Locations instead of where it pointed.
 *
 * Every branch-scoped page needs a branch, so for an org with none the entry
 * redirects send everything to `/dashboard/locations` — correctly, but
 * silently. Silently is the problem: on 2026-10-05 an operator clicked
 * "Catalog" again and again, each click bouncing straight back, with nothing on
 * screen to say the business simply had no location yet.
 *
 * One toast id, so a run of clicks refreshes a single notice rather than
 * stacking one per click. Call it only for a REAL navigation — the redirects
 * also run on hover preloads, and a notice for a link merely hovered is noise.
 */
export function noticeNoLocation(): void {
  toast.info('Add a location first', {
    id: 'no-location',
    description:
      'Calendar, catalog, clients and marketing are organised by location, so they open once this business has one.',
  });
}
